import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { SessionWarningComponent } from './components/global/session-warning/session-warning.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SessionWarningComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  
  private authService = inject(AuthService);

  ngOnInit(): void {
    this.authService.bootstrapAuthClient();
  }

}
